import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Free proxy list", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  alt: "section-shape",
  src: "https://cdn.proxyscrape.com/img/section-shape.png"
}, null, -1)
const _hoisted_7 = { id: "descn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" HTTP, Socks4 and Socks5 proxy lists updated 24/7. ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Want better & faster proxies? ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("go premium!")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  id: "descp",
  style: {"display":"none"}
}, " HTTP, Socks4 and Socks5 proxy lists updated 24/7 with premium features! ", -1)
const _hoisted_13 = {
  class: "col-lg-12 col-md-12 col-12",
  id: "nonepremium"
}
const _hoisted_14 = { class: "itemcard full" }
const _hoisted_15 = {
  id: "ad1",
  class: "box greenBox"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Want premium proxies that always work? ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("GET STARTED ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Loading... ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Loading... ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Loading... ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12 col-md-12 col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "itemcard full" }, [
    /*#__PURE__*/_createElementVNode("iframe", {
      src: "https://www.youtube.com/embed/rH7DwAFSbuA",
      width: "100%",
      height: "600",
      frameborder: "0",
      allowfullscreen: "true"
    }),
    /*#__PURE__*/_createElementVNode("a", { href: "/premium?ref=fastpwl" }, [
      /*#__PURE__*/_createElementVNode("button", { class: "btn loginbtn" }, "GET PROXIES")
    ])
  ])
], -1)

import ProxyTable from '@/components/freebies/free/ProxyTable.vue';
import WhyPremium from '@/components/freebies/free/WhyPremium.vue';
import BlogSection from '@/components/shared/BlogSection.vue';
import FProxiesFAQ from '@/components/freebies/free/FProxiesFAQ.vue';
import FProxiesDisclaimer from '@/components/freebies/free/FProxiesDisclaimer.vue';
import HttpProxies from '@/components/freebies/free/HttpProxies.vue';
import Socks4Proxies from '@/components/freebies/free/Socks4Proxies.vue';
import Socks5Proxies from '../components/freebies/free/Socks5Proxies.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _createVNode(_component_router_link, {
                to: "/premium?ref=topfpl",
                style: {"text-decoration":"underline"}
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_router_link, {
                to: "/premium",
                style: {"text-decoration":"underline"}
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ])
          ])
        ]),
        (_openBlock(), _createBlock(_Suspense, null, {
          fallback: _withCtx(() => [
            _hoisted_18
          ]),
          default: _withCtx(() => [
            _createVNode(HttpProxies)
          ]),
          _: 1
        })),
        (_openBlock(), _createBlock(_Suspense, null, {
          fallback: _withCtx(() => [
            _hoisted_19
          ]),
          default: _withCtx(() => [
            _createVNode(Socks4Proxies)
          ]),
          _: 1
        })),
        (_openBlock(), _createBlock(_Suspense, null, {
          fallback: _withCtx(() => [
            _hoisted_20
          ]),
          default: _withCtx(() => [
            _createVNode(Socks5Proxies)
          ]),
          _: 1
        })),
        _hoisted_21,
        _createVNode(ProxyTable),
        _createVNode(WhyPremium),
        _createVNode(BlogSection),
        _createVNode(FProxiesFAQ),
        _createVNode(FProxiesDisclaimer)
      ])
    ])
  ]))
}
}

})